var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine65(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 90,
    viewBox: "0 0 3 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.4002,
    x2: 1.4002,
    y2: 90,
    stroke: "#EAEAEA",
    strokeWidth: 1.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine65);
export default __webpack_public_path__ + "static/media/Line65.fed8032229386dd9bf610fda490cfe73.svg";
export { ForwardRef as ReactComponent };